var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ask_selectable)?_c('div',{staticClass:"align-center m-l-15",attrs:{"id":"btn_seleccion"}},[_c('b-form-checkbox',{attrs:{"unchecked-value":0,"button-variant":_vm.variant,"button":"","value":1},model:{value:(_vm.is_selecteable),callback:function ($$v) {_vm.is_selecteable=$$v},expression:"is_selecteable"}},[_vm._v(" Seleccion ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }